@import "../../theme/global";

:host {
  display: block;
  width: 100%;
  height: 100%;
}

.onoff-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 15rem;
  padding: 2rem;

  lar-toggle {
    transform: scale(2.5);
  }

  @media (max-width: 576px) {
    min-height: 12rem;

    lar-toggle {
      transform: scale(2);
    }
  }
}
